export const DEVICE_DETAIL_SHOW = "DEVICE_DETAIL_SHOW"
export const DEVICE_DETAIL_GET_DATA_REQUEST = "DEVICE_DETAIL_GET_DATA_REQUEST";
export const DEVICE_DETAIL_GET_DATA_REQUEST_RESULT = "DEVICE_DETAIL_GET_DATA_REQUEST_RESULT";
export const DEVICE_DETAIL_HIDE = "DEVICE_DETAIL_HIDE"
